module.exports = __webpack_public_path__ + "static/media/WebSurfer-snapshot.ce49deb5.png";


//////////////////
// WEBPACK FOOTER
// ./images/DashMobile/WebSurfer-snapshot.png
// module id = 446
// module chunks = 0